export enum SpecsCompareTypeEnum {
  CAMERA_FIXED_LENS = 1,
  CAMERA_INTERCHANGEABLE_LENS = 2,
  LENS = 3,
}